// extracted by mini-css-extract-plugin
export default {"checkbox_input":"Checkbox_checkbox_input__4lPAv","checkbox_label":"Checkbox_checkbox_label__6iFmK"};